import { render, staticRenderFns } from "./HonjoNumber.vue?vue&type=template&id=3a1b0a0a"
import script from "./HonjoNumber.vue?vue&type=script&lang=ts"
export * from "./HonjoNumber.vue?vue&type=script&lang=ts"
import style0 from "./HonjoNumber.vue?vue&type=style&index=0&id=3a1b0a0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports